import React from "react";
import IntroductionContainer from "./index.css";
import TimelineContainer from "./Timeline";

const Business = () => {
  return (
    <IntroductionContainer.BusinessDiv>
      <h1>협회사업</h1>
      <div className="Business">
        <div className="BusinessContent">
          <div className="BusinessHeader">
            <hr></hr>
            <p>목적</p>
          </div>
          <span>
            본 협회는 개개인이 가진 가치 있는 자식이나 재능을 이룰 필요로 하는
            사회 각계각층에 교육 ▫ 훈련을 또는 기부를 통해 확산시킴으로써
            개개인의 창의력 향상, 일자리 창출 확대, 소외계층에 대한 지원 사업 및
            균형 있는 사회통합과 국민경제 발전에 기여함을 목적으로 한다.
          </span>
        </div>
        <div className="BusinessContent">
          <div className="BusinessHeader">
            <hr></hr>
            <p>사업영역</p>
          </div>
          <span>
            복지 문화의 새로운 패러다임
            <span className="SpecialText">"재능기부"</span>
          </span>
          <ul>
            <li>다문화 결손 가정 지원 사업</li>
            <li>희귀, 난치병 환자 지원 사업</li>
            <li>장애인 및 소외계층 무료 결혼식 지원 사업</li>
            <li>장애인 일자리 창출 지원 사업</li>
            <li>재능나눔콘서트를 통한 소외계층 지원 사업</li>
            <li>재능나눔갤러리 콘서트를 통한 문화소외계층 지원 사업</li>
            <li>군부대 위문 공연 지원 사업</li>
            <li>무료 창업 스쿨 지원 사업</li>
            <li>우수 재능기부 천사 발굴 선정 사업</li>
            <li>재능기부 정보 교류 사엽</li>
          </ul>
        </div>
      </div>
      <h1>연혁</h1>
      <TimelineContainer></TimelineContainer>
    </IntroductionContainer.BusinessDiv>
  );
};

export default Business;
